require('/opt/odin/app/frontend/components/trial/top_bar/index.module.scss');module.exports = "../../app/cells/components/trial/top_bar/show.erb";